<section class="job-documents" *ngIf="viewModel$ | async as viewModel">
  <div>
    <header>
      <h2>Documents</h2>
      <div class="button-container">
        <p-button
          label="Create Document"
          icon="pi pi-plus"
          outlined="true"
          (onClick)="store.dispatch(actions.createDocumentButtonClicked())"
          [disabled]="viewModel.jobNotInZone"
        ></p-button>
        <p-button
          label="Upload Document"
          icon="pi pi-upload"
          (onClick)="store.dispatch(actions.uploadDocumentButtonClicked())"
          outlined="true"
          [disabled]="viewModel.jobNotInZone"
        ></p-button>
      </div>
    </header>
    <div class="document-container">
      <p-skeleton
        *ngIf="viewModel.jobLoading"
        class="flex-1"
        borderRadius="0.571rem"
        width="100%"
        height="6.25rem"
      ></p-skeleton>
      <div class="empty-state" *ngIf="viewModel.documentsEmpty">
        <i class="pi pi-file"></i>
        <span>No documents for this job.</span>
      </div>
      <app-job-estimate
        *ngFor="let document of viewModel.documents"
        [artifactId]="document.id"
      ></app-job-estimate>
      <app-job-invoice
        *ngFor="let invoice of viewModel.invoices"
        [invoiceId]="invoice.id"
      ></app-job-invoice>
    </div>
  </div>
</section>
